(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('sideInfoNotificationInterceptor', sideInfoNotificationInterceptor);

    sideInfoNotificationInterceptor.$inject = ['$q', 'AlertService','$rootScope'];

    function sideInfoNotificationInterceptor ($q, AlertService, $rootScope) {
        var service = {
        		response: response
        };

        return service;

        function response (response) {
            if (response.status == 200) {
                $rootScope.$emit('sideApp.httpInfo', response);
            }
            return response;
        }
    }
})();